<template>
  <!-- 锚点tabs -->
  <div class="anchor-tabs-index">
    <div class="tabs">
      <div class="tabs-content">
        <el-tabs v-model="activeName" @tab-click="handleTabClick(activeName)">
          <el-tab-pane
            :label="item.name"
            :name="item.value"
            v-for="item in tabList"
            :key="item.value"
          >
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      default: () => {
        return [
          {
            name: "All",
            value: "all",
          },
          {
            name: "Highlights",
            value: "highlights",
          },
          {
            name: "Function",
            value: "function",
          },
          {
            name: "Support",
            value: "support",
          },
          {
            name: "Contact",
            value: "contact",
          },
          {
            name: "Combination",
            value: "combination",
          },
        ];
      },
    },
  },
  data() {
    return {
      activeName: "all",
    };
  },
  created() {
    this.activeName = this.tabList[0].value;
  },
  methods: {
    handleTabClick(tabId) {
      console.log(tabId);
      const targetElement = document.getElementById(tabId);
      if (targetElement) {
        const headerOffset = 80; // 设置偏移量，根据实际菜单栏高度调整
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset - 64; // 本组件高度64px

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.anchor-tabs-index {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 80px;
  background: #fff;
  z-index: 20;
  .tabs {
    height: 64px;
    line-height: 64px;
    border-bottom: 1px solid #d8d8d8;
    .el-tabs__nav-wrap::after {
      display: none !important;
    }
    .el-tabs__item {
      color: #1d1d1f !important;
      font-size: 18px !important;
      opacity: 0.8;
    }
    .el-tabs__item.is-active {
      color: #1d1d1f !important;
      font-weight: bold !important;
      opacity: 1;
    }
    .el-tabs__item:hover {
      color: #1d1d1f !important;
      opacity: 1;
    }
    .el-tabs__active-bar {
      background-color: #0035fb !important;
    }
    .tabs-content {
      padding: 0;
      width: 1049px;
      margin: 0 auto;
      box-sizing: border-box;
    }
  }
}
</style>
